"use client"

import { memo } from "react";
import CategoryUnderline from "./CategoryUnderline";
import FeaturedCard from "../cards/FeaturedCard";
import StandardCard from "../cards/StandardCard";
import { getCategoryNamesEnglish, slugToEnglish } from "@/lib/helper";
import { useAuth } from "@/contexts/AuthContext";
import { GRID_COUNTS, take } from "@/lib/gridCounts";

function resolveCategorySlug(cat, hero, categories = []) {
    const matched = categories.find(
        (category) =>
            category.name === cat ||
            category.nameEnglish?.toLowerCase() === String(cat || "").toLowerCase() ||
            category.slug === String(cat || "").toLowerCase()
    )
    if (matched?.slug) return matched.slug

    const fromHero = getCategoryNamesEnglish(hero?.categoryIds, categories)
    if (Array.isArray(fromHero)) return fromHero[0] || ""
    if (typeof fromHero === "string" && fromHero) return fromHero

    return slugToEnglish(cat) || String(cat || "").toLowerCase()
}

const CategorySection = ({ cat, hero, stories, divider = false }) => {
    const { categories } = useAuth();
    const visibleStories = take(stories, GRID_COUNTS.CATEGORY_HERO_STORIES)
    const categorySlug = resolveCategorySlug(cat, hero, categories)
    const selectedCategory = categories.find(
        (category) =>
            category.name === cat ||
            category.slug === categorySlug ||
            category.nameEnglish?.toLowerCase() === String(cat || "").toLowerCase()
    ) || null

    return (
        <section className={`py-1 ${divider ? 'pt-4 border-t border-(--border-default)' : ''}`}>
            <CategoryUnderline
                name={cat}
                url={`/category/${categorySlug}`}
            />
            {/* Mobile / tablet: stacked */}
            <div className="lg:hidden">
                <FeaturedCard
                    headline={hero?.title}
                    data={hero}
                    selectedCategory={selectedCategory}
                />
                <div className="flex flex-col gap-3.5 mt-4 pt-4 border-t border-(--border-default)">
                    {visibleStories.map((s, i) => (
                        <StandardCard
                            key={i}
                            headline={s?.title}
                            imageUrl={s?.featuredImage}
                            data={s}
                            selectedCategory={selectedCategory}
                        />
                    ))}
                </div>
            </div>
            {/* Desktop: side-by-side */}
            <div className="hidden lg:grid grid-cols-[1.4fr_1fr] gap-5 items-start">
                <FeaturedCard
                    headline={hero?.title}
                    data={hero}
                    selectedCategory={selectedCategory}
                />
                <div className="flex flex-col gap-3.5">
                    {visibleStories.map((s, i) => (
                        <StandardCard
                            key={i}
                            headline={s?.title}
                            layout="row"
                            imageUrl={s?.featuredImage}
                            data={s}
                            selectedCategory={selectedCategory}
                        />
                    ))}
                </div>
            </div>
        </section>
    )
}

export default memo(CategorySection)
